import { createFileRoute } from '@tanstack/react-router';

import { TransactionAnalyticsPage } from './TransactionAnalyticsPage';

export const Route = createFileRoute('/_protected/_consumer/transaction-analytics/')({
  component: TransactionAnalyticsPage,
});
